import moment from 'moment';
import { SESSION_WINDOW, WHATSAPP_SESSION_WINDOW_HOURS } from './constants';
import { TChannelConversation, TSessionWindow } from './types';

/**
 * WhatsApp only accepts free-form messages within 24 h of the customer's last message.
 * Uses the window computed by the backend, or the last inbound message. Without
 * either, the window is unknown and the provider decides.
 */
export const getWhatsappSessionWindow = (
    conversation: TChannelConversation | null,
    now: Date
): TSessionWindow => {
    const expiresAt = conversation?.messagingWindowExpiresAt
        ? moment(conversation.messagingWindowExpiresAt)
        : conversation?.lastInboundMessageAt
          ? moment(conversation.lastInboundMessageAt).add(
                WHATSAPP_SESSION_WINDOW_HOURS,
                'hours'
            )
          : null;
    if (!expiresAt?.isValid()) return SESSION_WINDOW.UNKNOWN;
    return expiresAt.isAfter(now)
        ? SESSION_WINDOW.OPEN
        : SESSION_WINDOW.EXPIRED;
};

export const isWhatsappSessionOpen = (
    conversation: TChannelConversation | null,
    now: Date
): boolean =>
    getWhatsappSessionWindow(conversation, now) !== SESSION_WINDOW.EXPIRED;
